"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_router_1 = require("react-router");
var constants_1 = require("../../../../../common/constants/constants");
var queryParams_1 = require("../../../../../common/service/queryParams");
var useCheckoutContext_1 = require("./useCheckoutContext");
exports.useGqlNav = function () {
    var location = react_router_1.useLocation();
    var history = react_router_1.useHistory();
    var token = queryParams_1.default.getParam(constants_1.constants.TOKEN, location);
    var deal = useCheckoutContext_1.default().deal;
    var configurationSourceUrl = react_1.useMemo(function () { var _a, _b; return (_b = (_a = deal) === null || _a === void 0 ? void 0 : _a.car) === null || _b === void 0 ? void 0 : _b.configurationSourceUrl; }, [deal]);
    return {
        location: location,
        history: history,
        token: token,
        configurationSourceUrl: configurationSourceUrl,
    };
};
